import React, { Component } from "react";
import FreeFormWorkspace from "./free_form/index";
import GridWorkspace from "./grid/index";
import { resolveLayoutType } from "./converter";

export default class Workspace extends Component {
  render() {
    const layoutType = resolveLayoutType(this.props.shell);
    const Inner = layoutType === "grid" ? GridWorkspace : FreeFormWorkspace;
    return <Inner {...this.props} />;
  }
}
